import { createSelector } from 'reselect';
import logger from '@tcp/core/src/utils/loggerInstance';

export const getNavigationData = (state) => {
  return state?.Navigation.navigationData;
};

export const getHorizontalPlpProducts = (state) => {
  return state?.HorizontalCategory?.horizontalPlpProducts;
};

export const getIsInitialCall = (state) => {
  return state?.CategoryListingPage?.isInitialCall;
};

export const getIsHorizontalPlpLoading = (state) => {
  return state.HorizontalCategory?.isHorizontalPlpLoading;
};

export const getIsHplpInitialDataLoading = (state) => {
  return state.HorizontalCategory?.isHplpInitialDataLoading;
};

export const getNumberofSubcategoryFetched = (state) => {
  return state.HorizontalCategory?.subCategoryFetched;
};

export const getHlpCurrentCid = (state) => {
  return state.HorizontalCategory?.currentCid;
};

export const getLoadedInShopThisStore = (state) => {
  return state.ShopThisStore.loadedInShopThisStore;
};

export const getHorizontalPlpProductsSeoData = (state) => {
  return state.HorizontalCategory?.horizontalPlpProductsSeoData;
};

export const getHorizontalPlpFilters = (state) => state.HorizontalCategory?.filters;

export const getHplpAppliedFilters = (state) => state?.HorizontalCategory?.appliedFilters;

const getAppliedSortId = (state) => state?.HorizontalCategory?.appliedSortId;

export const getInitialHplpValues = createSelector(
  getHplpAppliedFilters,
  getAppliedSortId,
  (appliedFilters, appliedSortId) => {
    return {
      ...appliedFilters,
      sort: appliedSortId || '',
    };
  }
);

export const isHplp = (state) => state?.HorizontalCategory?.isHplp;

const getSortedl2Group = (l1SubCategories = {}) => {
  const level2Groups = Object.values(l1SubCategories);
  return level2Groups.sort((prevGroup, curGroup) => {
    return prevGroup.order - curGroup.order;
  });
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getNavigationCategoriesApp = (navData, catUrl) => {
  const categoryFound = [];
  if (!Array.isArray(navData)) return categoryFound;

  try {
    navData.some((l1) => {
      if (l1.url === catUrl && !l1?.categoryContent?.linkedCategory) {
        categoryFound.push(l1);
        return true;
      }

      const l2groupSort = getSortedl2Group(l1.subCategories);
      const l1CatFound = l2groupSort.some((l2group) => {
        return l2group.items.some((l2) => {
          if (l2.url === catUrl && !l2?.categoryContent?.linkedCategory) {
            categoryFound.push(l2);
            return true;
          }
          const l2CatFound = l2.subCategories.some((l3) => {
            if (l3.url === catUrl && !l3?.categoryContent?.linkedCategory) {
              categoryFound.push(l3);
              return true;
            }
            return false;
          });
          if (l2CatFound) {
            categoryFound.unshift(l2);
          }
          return l2CatFound;
        });
      });
      if (l1CatFound) {
        categoryFound.unshift(l1);
      }
      return l1CatFound;
    });
  } catch (e) {
    logger.error({
      error: `Error in Categorylistingpage selectors - ${e}`,
      extraData: {
        componentName: 'getNavigationCategoriesApp',
        categoryId: catUrl,
      },
    });
  }
  return categoryFound;
};
